<template>
  <CrudList
    title="Imagenes Reportadas"
    storeName="Report_pictures"
    labelAddNew="Agregar"
    slot-scope="{ item }"
    sortable
    canSearch
  >
    <template v-slot:user_id="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12" v-if="item.user_id">
          {{ item.user_id.full_name }}
        </v-col>
      </v-row>
    </template>

    <template v-slot:picture_id="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-list-item-avatar v-if="item.picture_id">
              <img :src="item.picture_id.picture_url" alt="" />
            </v-list-item-avatar>
          </v-col>
        </v-row>
      </template>
  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
};
</script>
